import React
    from "react";

const ErrorListItem = ({
                           error,
                           ...rest
                       }) => {
    return <li className='fz-form-field-error-messages-list-item' {...rest}>{error}</li>
}

export default ErrorListItem;